module.exports = {
  title: 'Logo',
  context: {
    url: 'http://adjoin.nitro/',
  },
}